// extracted by mini-css-extract-plugin
module.exports = {"clockIcon":"cancel-order_clockIcon__zGpZC"};